import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MaintenanceIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.08 7.86L15.88 8.66L19.1 5.44C20.54 7.26 20.42 9.98 18.74 11.66C17.5 12.88 15.92 13.28 14.42 12.88L7.42 19.88C6.44 20.86 4.84 20.84 3.86 19.88C2.9 18.9 2.88 17.3 3.86 16.32L10.86 9.32C10.46 7.82 10.86 6.24 12.08 5C13.76 3.32 16.48 3.2 18.3 4.64L15.08 7.86ZM15.96 10.56L13.18 7.78L15.88 5.1C14.72 4.96 13.72 5.44 13.12 6.04C12.12 7.04 11.96 8.62 12.6 9.82L5.02 17.4C4.64 17.8 4.66 18.36 5.02 18.72C5.38 19.08 5.94 19.1 6.34 18.72L13.92 11.14C15.12 11.78 16.7 11.62 17.7 10.62C18.3 10.02 18.78 9.02 18.64 7.86L15.96 10.56Z" />
    </SvgIcon>
  );
});
